// import React from "react";
// import { Button, DropdownButton, Dropdown } from "react-bootstrap";
// import "./pageheader.scss";
// import { useAppSelector } from "../../store/storeRequests";
// import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
// import { Content } from "../../pages/TrainingForm/ViewTrainingContent";

// interface ButtonConfig {
//   label: string;
//   theme: string;
//   icon?: JSX.Element;
//   onClick?: () => void;
//   disabled?: boolean | (() => boolean);
//   dropdown?: {
//     label: string;
//     onClick?: () => any;
//     onSelect?: (selectedValue: string) => void;
//     disabled?: boolean | (() => boolean);
//   }[];
// }

// interface PageHeaderProps {
//   buttons: ButtonConfig[];
// }

// const PageHeader: React.FC<PageHeaderProps> = ({ buttons }) => {
//   const { deleteIDs, moduleName } = useAppSelector(
//     StoreSelectors.PAGE_HEADER_STATE
//   );

//   const isDisabled = (disabled?: boolean | (() => boolean)) => {
//     if (typeof disabled === "function") {
//       return disabled();
//     }
//     return disabled || false;
//   };

//   return (
//     <div className="d-flex align-items-center justify-content-end page-header">
//       {buttons.map((button, index) => (
//         <div key={index} className="button-wrapper">
//           {button.dropdown ? (
//             <DropdownButton
//               id={`dropdown-button-${index}`}
//               title={button.label}
//               variant={button.theme}
//               className="custom-dropdown-button d-flex align-items-center justify-content-center gap-2"
//               disabled={isDisabled(button.disabled)}
//             >
//               {button.dropdown.map((item, idx) => (
//                 <Dropdown.Item
//                   key={idx}
//                   onClick={() => {
//                     if (!isDisabled(item.disabled)) {
//                       item.onClick?.();
//                       item.onSelect?.(item.label);
//                     }
//                   }}
//                   disabled={isDisabled(item.disabled)}
//                 >
//                   {item.label}
//                 </Dropdown.Item>
//               ))}
//             </DropdownButton>
//           ) : (
//             <Button
//               className={`custom-button btn-${button.theme} d-flex align-items-center justify-content-center`}
//               onClick={button.onClick}
//               disabled={isDisabled(button.disabled)}
//             >
//               <div className="button-content">
//                 {button.icon} <span>{button.label}</span>
//               </div>
//             </Button>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PageHeader;

import React from "react";
import { Button, DropdownButton, Dropdown } from "react-bootstrap";
import "./pageheader.scss";
import { useAppSelector } from "../../store/storeRequests";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";

interface ButtonConfig {
  label: string;
  theme: string;
  icon?: JSX.Element;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean | (() => boolean);
  dropdown?: {
    label: string;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSelect?: (selectedValue: string) => void;
    disabled?: boolean | (() => boolean);
  }[];
}

interface PageHeaderProps {
  buttons: ButtonConfig[];
}

const PageHeader: React.FC<PageHeaderProps> = ({ buttons }) => {
  const { deleteIDs, moduleName } = useAppSelector(
    StoreSelectors.PAGE_HEADER_STATE
  );

  const isDisabled = (disabled?: boolean | (() => boolean)) => {
    if (typeof disabled === "function") {
      return disabled();
    }
    return disabled || false;
  };

  return (
    <div className="d-flex align-items-center justify-content-end page-header">
      {buttons.map((button, index) => (
        <div key={index} className="button-wrapper">
          {button.dropdown ? (
            <DropdownButton
              id={`dropdown-button-${index}`}
              title={button.label}
              variant={button.theme}
              style={{fontSize: "14px"}}
              className="custom-dropdown-button d-flex align-items-center justify-content-center gap-2 "
              disabled={isDisabled(button.disabled)}
            >
              {button.dropdown.map((item, idx) => (
                <Dropdown.Item
                  key={idx}
                  style={{fontSize: "14px"}}
                  onClick={(event) => {
                    if (!isDisabled(item.disabled)) {
                      item.onClick?.(event); // Passing the event object
                      item.onSelect?.(item.label);
                      (event.currentTarget as HTMLElement).blur();
                    }
                  }}
                  disabled={isDisabled(item.disabled)}
                >
                  {item.label}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          ) : (
            <Button
              className={`custom-button btn-${button.theme} d-flex align-items-center justify-content-center`}
              onClick={(event) => { 
                button.onClick?.(event);
                (event.currentTarget as HTMLElement).blur();
              }} // Passing the event object
              disabled={isDisabled(button.disabled)}
            >
              <div className="button-content">
                {button.icon} <span>{button.label}</span>
              </div>
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default PageHeader;
